import {SVGAttributes} from 'react';
import styled, {css} from 'styled-components';

import {Color, colorVar} from '../Theme/colors';
import {sizes} from './defs';

interface Props extends Omit<SVGAttributes<SVGSVGElement>, 'color'> {
  size?: keyof typeof sizes;
  color?: Color;
}

const SvgIcon = styled.svg<Props>`
  aspect-ratio: 1;
  fill: currentColor;
  vertical-align: middle;
  user-select: none;
  display: inline-block;
  overflow: visible !important;
  ${({size}) => sizes[size || 'default']};
  ${({color}) =>
    color &&
    css`
      color: ${colorVar(color)} !important;
    `};
`;

export default SvgIcon;
